export function dataFormatter(value) {
  return new Date((Number(value) + 8 * 3600) * 1000)
    .toJSON()
    .substr(0, 10)
    .replace("T", " ");
}



